<template>
  <ProductSelect
    ref="selector"
    :items="fetchProducts"
    :promise="promise"
    type="modal-only"
    multiple
    select-all
    :host="catalog && `https://${catalog.source}`"
    class="product-catalog"
    @close="$emit('update:show', false)"
  >
    <template #header>
      <div v-if="catalog.description" class="product-catalog__header">
        <div class="card__title">
          <span>{{ catalog.label }}</span>
          <img class="product-catalog__logo" height="20px" :alt="catalog.label" :src="catalog.logo" />
        </div>
        <ReadMore :value="catalog.description" placement="center" class="product-catalog__description" />
      </div>
    </template>
    <template #sidebar-top>
      <div class="product-catalog__sidebar">
        <div class="card__title">{{ $t('productCatalog') }}</div>
        <div class="product-catalog__items">
          <ButtonComponent
            v-for="item in value"
            :key="item.source"
            :title="item.label"
            class="product-catalog__item"
            :class="{ 'product-catalog__item--active': item === catalog }"
            @click="catalog = item"
          >
            <template #default>
              <img :src="item.logo" :alt="item.label" />
            </template>
          </ButtonComponent>
        </div>
      </div>
    </template>
  </ProductSelect>
</template>

<script>
import fetch from '@/fetch'

import ProductSelect from '@/components/Product/Select/Modal'
import ReadMore from '@kvass/read-more'

export default {
  props: {
    value: Array,
    show: Boolean,
  },
  watch: {
    show: {
      handler(val) {
        if (!val) return this.$refs.selector && this.$refs.selector.$children[0].close()

        this.$refs.selector.$children[0].open()
        this.$refs.selector.$once('input', i => this.submit(i))

        this.catalog = this.value[0]
      },
      immediate: true,
    },
    catalog: {
      handler(val) {
        if (!val) return
        this.$refs.selector.$children[0].internalfetch()
      },
      immediate: true,
    },
  },
  data() {
    return {
      catalog: null,
      promise: null,
    }
  },
  methods: {
    async fetchProducts(filter) {
      if (!this.catalog) return []
      return fetch(`https://${this.catalog.source}/api/graphql`, {
        method: 'POST',
        credentials: 'omit',
        body: JSON.stringify({
          query: `
            query($filter: ProductFilter) {
              Products(filter: $filter) {
                id
                name
                demo
                net
                gross
                pricing {
                  value
                  type
                  margin {
                    value
                    type
                  }
                  vat
                  rounding
                }
                images {
                  name
                  size
                  type
                  url
                  dimensions
                }
              }
            }
          `,
          variables: {
            filter,
          },
        }),
      })
        .then(res => res.json())
        .then(res => (this.items = res.data.Products))
        .catch(error => {
          console.error('Fetch error', error)
        })
    },
    submit(items) {
      if (!items.length) return (this.promise = Promise.resolve())
      this.promise = fetch('/api/product/catalogs/import', {
        method: 'POST',
        body: JSON.stringify({ products: items.map(i => i.id), source: this.catalog.source }),
      }).then(() => this.$emit('refetch'))
    },
  },
  components: {
    ProductSelect,
    ReadMore,
  },
}
</script>

<style lang="scss">
.product-catalog {
  &__sidebar {
    margin-bottom: 2rem;
  }

  &__description {
    margin-bottom: 1rem;
    background-color: #f6f6f6;
    padding: 1rem;
    border-radius: var(--border-radius);

    p:first-child {
      margin-top: 0;
    }
  }

  &__items {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  &__item {
    padding: 0.75em 1.5em;

    img {
      max-height: 30px;
      padding: 5px;
    }

    &--active {
      background-color: css-alpha('primary', 0.05);
      border-color: css-alpha('primary', 0.3);
    }
  }
}
</style>
